import { useEffect, useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './ExitGameButton.css';

export default function ExitGameButton({ onExit, label = 'Exit Game', title = 'Exit game?',
  message = 'Return to your characters?', failureMessage = 'Unable to return to your characters. Please try again.', disabled = false }) {
  const [open, setOpen] = useState(false), [busy, setBusy] = useState(false), [error, setError] = useState('');
  const trigger = useRef(null), dialog = useRef(null), no = useRef(null), exiting = useRef(false);
  const titleId = useId();
  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow, button = trigger.current;
    document.body.style.overflow = 'hidden'; no.current?.focus();
    const keydown = event => {
      if (event.key === 'Escape') { event.preventDefault(); if (!exiting.current) setOpen(false); }
      if (event.key !== 'Tab') return;
      const controls = [...dialog.current.querySelectorAll('button:not(:disabled)')];
      const first = controls[0], last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (!dialog.current.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
      else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', keydown);
    return () => { document.removeEventListener('keydown', keydown); document.body.style.overflow = previousOverflow; button?.focus(); };
  }, [open]);
  const confirm = async () => {
    if (exiting.current) return;
    exiting.current = true; setBusy(true); setError('');
    try { await onExit(); setOpen(false); }
    catch (failure) { setError(failure?.message || failureMessage); }
    finally { exiting.current = false; setBusy(false); }
  };
  return <>
    <button ref={trigger} type="button" className="secondary-button play-exit-button" aria-haspopup="dialog" disabled={disabled}
      onClick={() => { setError(''); setOpen(true); }}>{label}</button>
    {open && createPortal(<div className="play-exit-overlay" onClick={event => {
      if (event.target === event.currentTarget && !exiting.current) setOpen(false);
    }}><section ref={dialog} className="play-exit-dialog" role="alertdialog" aria-modal="true" aria-labelledby={titleId} aria-busy={busy}>
      <h2 id={titleId}>{title}</h2><p>{message}</p>
      {error && <p role="alert">{error}</p>}
      <div className="button-row"><button type="button" className="secondary-button" disabled={busy} onClick={confirm}>Yes</button>
        <button ref={no} type="button" className="secondary-button" disabled={busy} onClick={() => setOpen(false)}>No</button></div>
    </section></div>, document.body)}
  </>;
}
